export function trackAnalyticsEvent(event: string, data: any | undefined = undefined) {
  if (window.posthog) {
    window.posthog.capture(event, data)
  }
}

export const AnalyticsEvents = {
  CLICK_SHARE_TRIPBOOK: 'ClickShareTripBook',
  CLICK_DOWNLOAD_TRIPBOOK: 'ClickDownloadTripBook',
    CLICK_CREATE_TRIPBOOK: 'ClickCreateTripBook',
  CLICK_DELETE_TRIPBOOK: 'ClickDeleteTripBook',
  CLICK_SEE_MORE_INFO_TRIPBOOK: 'ClickSeeMoreInfoTripBook',
  CLICK_EDIT_TRIPBOOK: 'ClickEditTripBook',
  CREATE_TRIPBOOK: 'CreateTripBook',
    UPDATE_TRIPBOOK: 'UpdateTripBook',

}
